import { createContext, useContext } from "react";

/** Space between the tabs and their action buttons, where the buttons wrap onto their own row */
export const WRAPPED_TAB_ACTION_BUTTONS_SPACING = "10px";

/** Whether the action buttons of the tabs wrap onto their own row below the tabs */
export const TabActionButtonsWrappedContext = createContext(false);

/**
 * Returns whether the action buttons of the tabs wrap onto their own row below the tabs,
 * e.g. to show a control of the tab next to them only where that row has room for it
 */
export function useAreTabActionButtonsWrapped() {
  return useContext(TabActionButtonsWrappedContext);
}